<script setup lang="ts">
import { ref } from 'vue'
import { RouterLink } from 'vue-router'
import { Menu, X } from 'lucide-vue-next'
import LogoMark from '@/components/public/LogoMark.vue'

const mobileOpen = ref(false)

const links = [
  { label: 'Product', to: '/#features' },
  { label: 'Integrations', to: '/integrations' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Resources', to: '/resources' },
]
</script>

<template>
  <header class="sticky top-0 z-40 border-b border-neutral-200 bg-white/90 backdrop-blur">
    <div class="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-8">
      <RouterLink to="/" class="flex items-center" @click="mobileOpen = false">
        <LogoMark variant="dark" class="h-6 w-auto" />
      </RouterLink>

      <nav class="hidden items-center gap-8 text-sm text-neutral-600 md:flex">
        <template v-for="l in links" :key="l.label">
          <a v-if="l.to.startsWith('/#')" :href="l.to" class="hover:text-neutral-900">{{ l.label }}</a>
          <RouterLink v-else :to="l.to" class="hover:text-neutral-900">{{ l.label }}</RouterLink>
        </template>
      </nav>

      <div class="hidden items-center gap-4 md:flex">
        <RouterLink to="/auth/" class="text-sm font-medium text-neutral-700 hover:text-neutral-900">
          Sign in
        </RouterLink>
        <RouterLink
          to="/auth/signup"
          class="rounded-lg bg-neutral-950 px-4 py-2 text-sm font-semibold text-white hover:bg-neutral-800"
        >
          Get started
        </RouterLink>
      </div>

      <button
        type="button"
        class="inline-flex items-center justify-center rounded-md p-2 text-neutral-700 md:hidden"
        @click="mobileOpen = !mobileOpen"
      >
        <Menu v-if="!mobileOpen" class="size-5" />
        <X v-else class="size-5" />
      </button>
    </div>

    <div v-if="mobileOpen" class="border-t border-neutral-200 bg-white px-6 py-4 md:hidden">
      <nav class="flex flex-col gap-4 text-sm text-neutral-700">
        <template v-for="l in links" :key="l.label">
          <a v-if="l.to.startsWith('/#')" :href="l.to" @click="mobileOpen = false">{{ l.label }}</a>
          <RouterLink v-else :to="l.to" @click="mobileOpen = false">{{ l.label }}</RouterLink>
        </template>
        <hr class="border-neutral-200" />
        <RouterLink to="/auth/" @click="mobileOpen = false">Sign in</RouterLink>
        <RouterLink
          to="/auth/signup"
          class="rounded-lg bg-neutral-950 px-4 py-2 text-center font-semibold text-white"
          @click="mobileOpen = false"
        >
          Get started
        </RouterLink>
      </nav>
    </div>
  </header>
</template>
